import { FC } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

import { isEmpty } from 'lodash/fp';

import useLocalizedFilters from '../../hooks/use-localized-filters';
import { styled } from '../../theme';
import { AgeGroupsOrder, DataFilters, DataType } from '../../types';
import Tooltip from '../Tooltip';
import FilterChips from './FilterChips';
import { ChipsRow } from './styles';

const TooltipContentWrapper = styled.div({
    maxWidth: 400,
});

export interface AppliedFiltersInfoProps {
    dataType: DataType;
    filters: DataFilters;
    ageGroupsOrder?: AgeGroupsOrder | null;
    dataCollectionName?: string;
}

const AppliedFiltersInfo: FC<AppliedFiltersInfoProps> = ({
    dataType,
    filters,
    ageGroupsOrder,
    dataCollectionName,
}) => {
    const localizedFilters = useLocalizedFilters(dataType, filters, ageGroupsOrder);

    if (isEmpty(localizedFilters) && !dataCollectionName) {
        return null;
    }

    return (
        <Tooltip
            title={
                <TooltipContentWrapper>
                    <ChipsRow>
                        <FilterChips
                            localizedFilters={localizedFilters}
                            dataCollectionName={dataCollectionName}
                        />
                    </ChipsRow>
                </TooltipContentWrapper>
            }
            trigger="hover"
            placement="bottom-start"
        >
            <FaInfoCircle size={16} aria-hidden="true" />
        </Tooltip>
    );
};

export default AppliedFiltersInfo;
